// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__jI1Me","file":"styles_file__3EXv0"};